var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.18 295",
    style: {
      enableBackground: "new 0 0 318.18 295"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000075132365743897965480000009137488229598292408_);}\n\t.st2{fill:url(#SVGID_00000055703779160826831990000004626162515288452243_);}\n\t.st3{fill:url(#SVGID_00000123434448721441878250000013219290554285278601_);}\n\t.st4{fill:url(#SVGID_00000106124658375579928520000006647235694617242291_);}\n\t.st5{fill:url(#SVGID_00000088102345348985424170000011025238378247342009_);}\n\t.st6{fill:url(#SVGID_00000071532092177103669560000017507699627778727866_);}\n\t.st7{fill:url(#SVGID_00000066500369567160596810000010449872680061028014_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1390.118,
    y1: -1300.1713,
    x2: 568.9869,
    y2: 519.3986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.06,20.3H44.58c-8.7,0-15.78,7.08-15.78,15.78v176.61c0,2.08,1.69,3.77,3.77,3.77h21.38v46.53 c0,9.01,7.33,16.35,16.35,16.35h175.9c9.01,0,16.35-7.33,16.35-16.35v-46.53h21.52c2.08,0,3.77-1.69,3.77-3.77V36.08 C287.84,27.38,280.76,20.3,272.06,20.3z M44.58,27.84h227.48c4.54,0,8.24,3.69,8.24,8.24v21.94H36.34V36.08 C36.34,31.54,40.04,27.84,44.58,27.84z M255,262.99c0,4.85-3.95,8.8-8.8,8.8H70.3c-4.85,0-8.8-3.95-8.8-8.8v-150.9 c0-4.85,3.95-8.8,8.8-8.8h175.9c4.85,0,8.8,3.95,8.8,8.8V262.99z M262.55,208.92v-96.83c0-9.01-7.33-16.35-16.35-16.35H70.3 c-9.01,0-16.35,7.33-16.35,16.35v96.82h-17.6V65.57h243.95v143.35H262.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044180108488072062940000008732183538791182720_",
    gradientUnits: "userSpaceOnUse",
    x1: -1389.3151,
    y1: -1301.0388,
    x2: 569.7918,
    y2: 518.5327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044180108488072062940000008732183538791182720_)"
    },
    d: "M57.72,52.99c2.08,0,3.77-1.69,3.77-3.77 V36.65c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v12.57C53.95,51.3,55.64,52.99,57.72,52.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049904643370708297190000016602797740600780167_",
    gradientUnits: "userSpaceOnUse",
    x1: -1377.662,
    y1: -1313.574,
    x2: 581.4369,
    y2: 505.9902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049904643370708297190000016602797740600780167_)"
    },
    d: "M82.87,52.99c2.08,0,3.77-1.69,3.77-3.77 V36.65c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v12.57C79.1,51.3,80.79,52.99,82.87,52.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120519119624184031980000015330721949141913761_",
    gradientUnits: "userSpaceOnUse",
    x1: -1366.0209,
    y1: -1326.1202,
    x2: 593.086,
    y2: 493.4514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120519119624184031980000015330721949141913761_)"
    },
    d: "M108.02,52.99c2.08,0,3.77-1.69,3.77-3.77 V36.65c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v12.57C104.25,51.3,105.94,52.99,108.02,52.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135671533907042992260000008267449362477244574_",
    gradientUnits: "userSpaceOnUse",
    x1: -1469.031,
    y1: -1215.2064,
    x2: 490.0732,
    y2: 604.3628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135671533907042992260000008267449362477244574_)"
    },
    d: "M108.02,234.07H82.87 c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.77,3.77,3.77h25.15c2.08,0,3.77-1.69,3.77-3.77S110.1,234.07,108.02,234.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063629847633073058720000001944455108881206150_",
    gradientUnits: "userSpaceOnUse",
    x1: -1451.6254,
    y1: -1233.9465,
    x2: 507.4784,
    y2: 585.6222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063629847633073058720000001944455108881206150_)"
    },
    d: "M133.03,221.49 c-9.01,0-16.35,7.33-16.35,16.35s7.33,16.35,16.35,16.35c9.01,0,16.35-7.33,16.35-16.35S142.04,221.49,133.03,221.49z  M133.03,246.64c-4.85,0-8.8-3.95-8.8-8.8s3.95-8.8,8.8-8.8c4.85,0,8.8,3.95,8.8,8.8S137.88,246.64,133.03,246.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149367570914648154640000015421312630963027599_",
    gradientUnits: "userSpaceOnUse",
    x1: -1422.4741,
    y1: -1265.3325,
    x2: 536.629,
    y2: 554.2355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149367570914648154640000015421312630963027599_)"
    },
    d: "M233.63,234.07h-75.31 c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.77,3.77,3.77h75.31c2.08,0,3.77-1.69,3.77-3.77S235.71,234.07,233.63,234.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060733742263362162150000007197313006754170774_",
    gradientUnits: "userSpaceOnUse",
    x1: -1411.2826,
    y1: -1277.389,
    x2: 547.8221,
    y2: 542.1805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060733742263362162150000007197313006754170774_)"
    },
    d: "M130.71,203.29 c0.62,0.4,1.33,0.6,2.04,0.6c0.42,0,0.85-0.07,1.26-0.22c19.63-6.97,40.01-17.69,60.58-31.89c1.01-0.7,1.62-1.85,1.63-3.09 c0.01-1.23-0.59-2.39-1.6-3.1c-19.47-13.72-39.28-24.15-60.58-31.9c-1.09-0.4-2.3-0.27-3.28,0.34c-0.98,0.61-1.63,1.64-1.75,2.8 c-2.06,19.09-2.06,39.89-0.01,63.6C129.1,201.61,129.73,202.66,130.71,203.29z M136.03,142.5c17.32,6.69,33.68,15.29,49.74,26.15 c-16.86,11.22-33.52,20.01-49.66,26.2C134.66,175.64,134.64,158.42,136.03,142.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep02);
export default __webpack_public_path__ + "static/media/step_02.d120218352fcfbd7c6042dcf164955eb.svg";
export { ForwardRef as ReactComponent };